'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardTeamCtrl', ['$uibModal', 'dialog', 'Department', '$stateParams', '$state', 'teams', 'team','$scope', require('./dashboardTeamCtrl')]);
app.directive('team', require('./dashboardTeamDirective'));
app.config(['$stateProvider', require('./dashboardTeamConfig')]);
